import React from 'react';
import {
  StyleSheet, ScrollView, View, Text,
  ActivityIndicator,
} from 'react-native';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import ListIcon16 from '../../../16pxIcons/ListIcon16';
import ProgressBarTile, { ProgressBarDataItem } from '../../ProgressBarWidget/ProgressBarTile';
import { WidgetSize } from '../../../../widgetConfig';
import Colors from '../../../../constants/Colors';

interface MostUtilizedSpacesWidgetProps {
  data?: ProgressBarDataItem[],
  comparisonData?: ProgressBarDataItem[],
  size?: WidgetSize,
}

const MostUtilizedSpacesWidget = ({
  size, data, comparisonData,
}: MostUtilizedSpacesWidgetProps) => {
  const renderTwoLists: boolean = size === WidgetSize.LARGE;
  const dataExists: boolean = data?.length > 0;

  return <SpaceUtilizationWidget
    title='Most utilised locations'
    tooltipText='Shown here is a list of locations ordered by percentage of capacity utilised'
    icon={<ListIcon16 />}
    content={<>
      {dataExists && <ScrollView
        nestedScrollEnabled
        style={styles.list}
        contentContainerStyle={styles.listContent}
      >
        <View style={{ flexDirection: 'row' }}>
          <View style={[{ flex: 1 }, renderTwoLists && { marginEnd: 8 }]}>
            {data.slice(0, 5)
              .map(({ title, value, onPress }
                : ProgressBarDataItem, index: number) => <ProgressBarTile
                  {...{ title, value, onPress }}
                  style={styles.tile}
                  key={`most_utilized_space_${index}`}
                  comparisonValue={comparisonData?.[index]?.value}
                />)}
          </View>
          {renderTwoLists && <View style={[{ flex: 1 }, renderTwoLists && { marginStart: 8 }]}>
            {data.slice(5, 10)
              .map(({ title, value, onPress }
                : ProgressBarDataItem, index: number) => <ProgressBarTile
                  {...{ title, value, onPress }}
                  style={styles.tile}
                  key={`most_utilized_space_${index}`}
                  comparisonValue={comparisonData?.[index + 5]?.value}
                />)}
          </View>}
        </View>
      </ScrollView>}
      {!dataExists && (data ? <Text style={styles.emptyText}>{'No data available'}</Text>
        : <ActivityIndicator
          size='large'
          style={styles.loadingIndicator}
        />)}
    </>}
    style={styles.container}
  />;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingBottom: 0,
    alignSelf: 'stretch',
  },
  list: {
    marginHorizontal: -16,
  },
  listContent: {
    paddingHorizontal: 16,
    paddingBottom: 8,
  },
  tile: {
    width: '100%',
    marginStart: 0,
    marginTop: 0,
  },
  emptyText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: '5%',
    marginBottom: '15%',
  },
  loadingIndicator: {
    marginTop: '5%',
    marginBottom: '10%',
  },
});

export default MostUtilizedSpacesWidget;
